<build-section
  [disabled]="disabled"
  [title]="'cakeBuilder.cakeTextSection.title' | translate">
  <div class="mb-2"
       *ngIf="price !== undefined">
    <span
      [translate]="'cakeBuilder.cakeTextSection.textCost'"></span>&nbsp;<span>{{price | currencyFormat}} {{currency}}</span>
  </div>
  <div class="form-group mb-2">
    <ui-expandable-textarea
      [placeholder]="'common.textareaPlaceholder' | translate"
      [(model)]="text"
      [rows]="1"
      [allowEmoji]="false"
      (modelChange)="textChanged$.next($event)">
    </ui-expandable-textarea>
  </div>
  <div class="fw-bold font-sm">
    {{ 'common.limitLetters' | translate:{"length": textLength, "maxLength": maxLength} }}
  </div>
  <div class="help-text" *ngIf="helpText">{{helpText}}</div>
</build-section>
